<template>
  <v-form ref="addLease" v-model="valid" lazy-validation>
    <v-container>
      <v-layout row>
        <v-flex xs6 md4>
          <v-layout row>
            <v-flex align-self-center shrink>
              <v-icon large color="light-green lighten-1">
                calendar_today
              </v-icon>
            </v-flex>
            <v-flex grow>
              <v-menu
                v-model="displayLeaseStartDate"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formatDate(lease.checkin_date)"
                    label="Rental Start Date"
                    readonly
                    required
                    :rules="[(v) => !!v || '']"
                    :disabled="isDisabled"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="lease.checkin_date"
                  no-title
                  @input="
                    displayLeaseStartDate = false
                  "
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs6 md4>
          <v-layout row>
            <v-flex align-self-center shrink>
              <v-icon large color="red lighten-2">calendar_today</v-icon>
            </v-flex>
            <v-flex grow>
              <v-menu
                v-model="displayLeaseEndDate"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formatDate(lease.checkout_date)"
                    label="Rental End Date"
                    readonly
                    required
                    :rules="[(v) => !!v || '']"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="lease.checkout_date"
                  no-title
                  @input="
                    displayLeaseEndDate = false
                  "
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex sm12 md4>
          <v-text-field
            v-model="lease.rent"
            :rules="[v => !!v || '']"
            label="Rent ($)"
            messages="Rent per week"
            required
          ></v-text-field>
        </v-flex>
        <v-flex sm12 md4>
          <v-select
            v-model="lease.pay_frequency"
            :rules="[v => !!v || '']"
            :items="[
              { name: '1 Week', value: 1 },
              { name: '2 Weeks', value: 2 },
              { name: '4 Weeks', value: 4 },
            ]"
            label="Pay Frequency"
            item-text="name"
            item-value="value"
          ></v-select>
        </v-flex>
        <v-flex sm12 md4>
          <v-layout row>
            <v-flex align-self-center shrink>
              <v-icon>calendar_today</v-icon>
            </v-flex>
            <v-flex grow>
              <v-menu
                v-model="displayFirstPayDate"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="formatDate(lease.first_payment_date)"
                    label="First Payment Date"
                    readonly
                    required
                    :rules="[(v) => !!v || '']"
                    :disabled="isDisabled"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="lease.first_payment_date"
                  no-title
                  @input="
                    displayFirstPayDate = false
                  "
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex sm12 md4>
          <v-radio-group
            v-model="lease.mgmt_fee_type"
            :rules="[v => !!v || '']"
            column
            label="Management Fee">
            <v-radio label="Fixed Rate" :value="2"></v-radio>
            <v-radio label="Percentage (%)" :value="1"></v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex sm12 md3>
          <v-text-field
            v-model="lease.mgmt_fee_rate"
            :rules="[v => !!v || '']"
            label="Rate"
            messages="Management fee per week"
            required
          >
            <template v-slot:append>
              <span v-if="lease.mgmt_fee_type === '1'">%</span>
            </template>
          </v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'LeaseInfo',
  props: {
    lease: {
      type: Object,
      default: function() {
        return {
          checkin_date: '',
          checkout_date: '',
          first_payment_date: '',
          rent: '',
          pay_frequency: '',
          mgmt_fee_type: '',
          mgmt_fee_rate: '',
          mgmt_fee_fixed: ''
        }
      },
    },
  },
  data() {
    return {
      displayLeaseStartDate: false,
      displayLeaseEndDate: false,
      displayFirstPayDate: false,
      valid: true,
    }
  },
  computed: {
    ...mapGetters({
      selectedHouse: 'HouseList/getSelectedHouse'
    }),
    isDisabled() {
      return this.$route.name !== 'houseDetailLeaseAdd'
    },
  },
  mounted() {
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format('DD MMMM YYYY') : null
    },
  }
}
</script>
